<template>
  <UHeader
    v-bind="props"
    :ui="{
      root: 'h-16',
    }"
  >
    <template #title>
      <div class="flex items-center gap-2">
        <UAvatar
          :src="LogoImage"
          :ui="{
            image: 'size-5',
            root: 'rounded-xl',
          }"
          alt="kasa-icon"
        ></UAvatar>
        <div class="flex items-center gap-2">
          <span
            class="line-clamp-1"
            :class="{
              'text-xl font-bold': largerOrEqualThanSm,
              'text-sm font-semibold': !largerOrEqualThanSm,
            }"
          >
            รายงาน KOSA
          </span>
        </div>
      </div>
    </template>

    <template #right>
      <slot name="right"></slot>
    </template>

    <template #body>
      <slot name="body"></slot>
    </template>
  </UHeader>
</template>

<script lang="ts" setup>
import LogoImage from "@/assets/images/logo.svg";
import type { HeaderProps } from "@nuxt/ui";
import { breakpointsTailwind } from "@vueuse/core";

const props = withDefaults(defineProps<HeaderProps>(), { toggle: false });

const breakpoints = useBreakpoints(breakpointsTailwind);
const largerOrEqualThanSm = breakpoints.greaterOrEqual("sm");
</script>

<style></style>
